import { t } from '@/plugins/i18n.ts';

import { getEmptySelectOption, getPriorityRangeText, getStringDropdownOption } from '../utils';

const EMPTY_ALERT_TYPE_OPTION = getEmptySelectOption(t('Select alert type'));
const EMPTY_PRIORITY_OPTION = getEmptySelectOption(t('Select priority'));
const EMPTY_RULE_VALUE_OPTION = getEmptySelectOption(t('Select rule note'));
const EMPTY_TARGET_TYPE_OPTION = getEmptySelectOption(t('Select target type'));
const EMPTY_VEHICLE_LIST_OPTION = getEmptySelectOption(t('Select vehicle list'));

const RULE_PRIORITIES = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const DEFAULT_PRIORITY_OPTION = getStringDropdownOption({ text: `9 (${getPriorityRangeText(9)})`, value: '9' });

// ['een.lprPlateReadEvent.v1'] is the default event type for VSP
const VSP_DEFAULT_EVENT_TYPE = ['een.lprPlateReadEvent.v1'];

const DEFAULT_PRIORITY_RANGE = [1, 10];

export {
  DEFAULT_PRIORITY_OPTION,
  DEFAULT_PRIORITY_RANGE,
  EMPTY_ALERT_TYPE_OPTION,
  EMPTY_PRIORITY_OPTION,
  EMPTY_RULE_VALUE_OPTION,
  EMPTY_TARGET_TYPE_OPTION,
  EMPTY_VEHICLE_LIST_OPTION,
  RULE_PRIORITIES,
  VSP_DEFAULT_EVENT_TYPE,
};
